var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.dataToShow
    },
    on: {
      "close": _vm.close
    }
  }, [_vm.step == 1 ? _c('div', {
    on: {
      "drop": function ($event) {
        $event.preventDefault();
        return _vm.addTempFile.apply(null, arguments);
      },
      "dragover": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "my-5 mx-5 lg:mx-20 xl:my-15 xl:mx-40 2xl:my-20 2xl:mx-32"
  }, [_c('h3', {
    staticClass: "mb-10"
  }, [_vm._v("\n        Ajouter un média\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "bg-indigo-100 rounded-lg flex flex-col items-center space-y-3 p-10 lg:px-0 py-24"
  }, [_c('icon', {
    staticClass: "hidden lg:block text-pink-600 w-12 h-12",
    class: {
      'animate-pulse': _vm.addNewFileLoading
    },
    attrs: {
      "name": "file"
    }
  }), _vm._v(" "), !_vm.addNewFileLoading ? _c('div', {
    staticClass: "flex flex-col items-center space-y-3"
  }, [_c('h3', {
    staticClass: "hidden lg:block text-indigo-600"
  }, [_vm._v("\n            Glissez & Déposez\n          ")]), _vm._v(" "), _c('h6', {
    staticClass: "hidden lg:block text-gray-600"
  }, [_vm._v("\n            ou "), _c('input', {
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "id": "upload-file"
    },
    on: {
      "change": _vm.addTempFile
    }
  }), _c('label', {
    staticClass: "underline cursor-pointer",
    attrs: {
      "for": "upload-file"
    }
  }, [_vm._v("sélectionnez")]), _vm._v(" votre média\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "lg:hidden"
  }, [_c('input', {
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "id": "upload-file"
    },
    on: {
      "change": _vm.addTempFile
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "upload-file"
    }
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-indigo-600",
      "text-color": "text-white",
      "bg-color": "bg-indigo-600",
      "icon-color": "text-white",
      "bg-color-square": "bg-indigo-600",
      "libelle": "Sélectionner un média",
      "icon": "file-add",
      "type-shadow": "shadow-indigo",
      "uppercase": true
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-red-500 text-sm"
  }, [_vm._v("\n            " + _vm._s(((_vm.errors || []).file || [])[0]) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "text-red-500 text-sm"
  }, [_vm._v("\n            " + _vm._s(((_vm.errors || []).forbidden || [])[0]) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "text-red-500 text-sm"
  }, [_vm._v("\n            " + _vm._s(((_vm.errors || []).media || [])[0]) + "\n          ")])]) : _vm._e(), _vm._v(" "), _vm.addNewFileLoading ? _c('div', [_c('h6', {
    staticClass: "text-gray-600 animate-pulse"
  }, [_vm._v("\n            Fichier en cours d'envoi...\n          ")])]) : _vm._e()], 1)])]) : _vm.step == 2 ? _c('div', [_c('h3', {
    staticClass: "my-16 text-pink-600"
  }, [_vm._v("\n      Média ajouté\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col lg:flex-row mx-5 xl:mx-15 mt-5 lg:mt-0 mb-5 gap-y-5 lg:gap-x-15 items-center"
  }, [_c('div', {
    staticClass: "flex flex-col"
  }, [_vm.fileTemp.id !== '' ? _c('img', {
    staticClass: "object-fill rounded-lg h-64",
    attrs: {
      "src": _vm.mode === 'new' || _vm.fileTemp.tempPath ? '/' + _vm.fileTemp.tempPath : '/portfolio/' + _vm.infosPass.id_pass + '/' + _vm.fileTemp.filename
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-indigo-600 cursor-pointer italic text-base text-center font-medium",
    on: {
      "click": [function ($event) {
        _vm.step = 1;
      }, function ($event) {
        $event.stopPropagation();
      }]
    }
  }, [_vm._v("\n          Changer d'image\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-6 items-center gap-x-10 gap-y-4 w-full"
  }, [_c('div', {
    staticClass: "col-span-full lg:col-span-2"
  }, [_vm._v("\n          Nom :\n        ")]), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-4",
    attrs: {
      "name": "nom",
      "value": _vm.fileTemp.name,
      "libelle": "",
      "error": true,
      "msg-error": ((_vm.errors || {}).name || [])[0]
    },
    on: {
      "input": function (newValue) {
        _vm.fileTemp.name = newValue;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-span-full lg:col-span-2"
  }, [_vm._v("\n          Description :\n        ")]), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-4",
    attrs: {
      "name": "description",
      "value": _vm.fileTemp.description,
      "libelle": ""
    },
    on: {
      "input": function (newValue) {
        _vm.fileTemp.description = newValue;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-span-full lg:col-span-2"
  }, [_vm._v("\n          Catégorie :\n        ")]), _vm._v(" "), _c('multiple-select', {
    staticClass: "lg:col-span-4",
    attrs: {
      "name": "categories",
      "datas": _vm.categories.map(function (cat) {
        return {
          value: cat
        };
      }),
      "left": false,
      "value": _vm.fileTemp.categories,
      "libelle": "",
      "adddata": true,
      "msg-error": _vm.errorCategories,
      "error": true,
      "max-length-new-libelle": 26
    },
    on: {
      "input": function (newValue) {
        _vm.fileTemp.categories = newValue;
      },
      "errorMaxLengthNewLibelle": function (msg) {
        _vm.errorCategories = msg;
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-red-500 text-sm my-10"
  }, [_vm._v("\n      " + _vm._s(((_vm.errors || []).forbidden || [])[0]) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex w-full justify-center my-15"
  }, [_vm.mode === 'new' ? _c('action-button', {
    attrs: {
      "border-color": "border-pink-600",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "icon-color": "text-white",
      "bg-color-square": "bg-pink-600",
      "libelle": "Continuer",
      "icon": "arrow-right_1",
      "right": true,
      "spinner": false,
      "type-shadow": "shadow-pink",
      "uppercase": true
    },
    on: {
      "clickAction": _vm.uploadFile
    }
  }) : _vm._e(), _vm._v(" "), _vm.mode === 'edit' ? _c('action-button', {
    attrs: {
      "border-color": "border-pink-600",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "icon-color": "text-white",
      "bg-color-square": "bg-pink-600",
      "libelle": "Modifier",
      "icon": "edit",
      "right": true,
      "spinner": false,
      "type-shadow": "shadow-pink",
      "uppercase": true
    },
    on: {
      "clickAction": _vm.editFile
    }
  }) : _vm._e()], 1)]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }